import React from 'react'
import AccountCards from './account-card/account-cards'
import BreadCum from './bread-cum'
import Layout from './layout'
import Navigation from './navigation'

export default function LayoutWithAccountCard({ children, breadCumKey = '', pageTitle = '' }) {
  return (
    <Layout>
      <div className='d-flex'>
        <Navigation />
        <div style={{ width: '100%' }}>
          <BreadCum breadCumKey={breadCumKey} pageTitle={pageTitle} />
          <div className='d-flex'>
            <AccountCards />
            <div style={{ width: '100%', paddingLeft: 20 }}>{children}</div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
